import { reducedMotion, pageVisible } from './env';
import { ratio } from './scale';

/*
 * Tuyết/bụi sáng rơi nhẹ trên KV. Chỉ chạy khi khung đang hiển thị + tab đang mở + người dùng không tắt chuyển động.
 * Vẽ bằng 1 sprite chấm mờ dựng sẵn (drawImage rẻ hơn shadowBlur rất nhiều).
 */
const COUNT = 46;

function makeSprite() {
  const s = document.createElement('canvas');
  s.width = s.height = 32;
  const g = s.getContext('2d');
  const grad = g.createRadialGradient(16, 16, 0, 16, 16, 16);
  grad.addColorStop(0, 'rgba(255,255,255,1)');
  grad.addColorStop(0.35, 'rgba(255,255,255,.55)');
  grad.addColorStop(1, 'rgba(255,255,255,0)');
  g.fillStyle = grad;
  g.fillRect(0, 0, 32, 32);
  return s;
}

export function createParticles(canvas) {
  if (!canvas || reducedMotion.matches) return { start() {}, stop() {} };
  const ctx = canvas.getContext('2d');
  const sprite = makeSprite();
  let w = 0;
  let h = 0;
  let k = 1;
  let raf = 0;
  let last = 0;
  let running = false;
  const parts = [];

  function resize() {
    w = canvas.clientWidth;
    h = canvas.clientHeight;
    // độ phân giải vẽ bám theo kích thước thật trên màn hình (wrapper đang bị scale), giới hạn để nhẹ GPU
    k = Math.min(1.5, ratio() * (window.devicePixelRatio || 1));
    canvas.width = Math.round(w * k);
    canvas.height = Math.round(h * k);
  }

  function spawn(p, anywhere) {
    p.x = Math.random() * w;
    p.y = anywhere ? Math.random() * h : -20;
    p.r = 3 + Math.random() * 7;
    p.vy = 18 + Math.random() * 42;
    p.sway = 10 + Math.random() * 30;
    p.phase = Math.random() * Math.PI * 2;
    p.a = 0.25 + Math.random() * 0.55;
    return p;
  }

  function tick(t) {
    const dt = Math.min(0.05, (t - last) / 1000 || 0);
    last = t;
    ctx.setTransform(k, 0, 0, k, 0, 0);
    ctx.clearRect(0, 0, w, h);
    for (const p of parts) {
      p.y += p.vy * dt;
      p.phase += dt * 0.8;
      const x = p.x + Math.sin(p.phase) * p.sway;
      if (p.y > h + 20) spawn(p, false);
      ctx.globalAlpha = p.a;
      ctx.drawImage(sprite, x - p.r, p.y - p.r, p.r * 2, p.r * 2);
    }
    if (running) raf = requestAnimationFrame(tick);
  }

  let ready = false;
  window.addEventListener('resize', () => ready && resize());

  return {
    start() {
      if (running || !pageVisible()) return;
      // đo kích thước lần đầu khi khung đã hiển thị (lúc khởi tạo khung có thể đang bị content-visibility ẩn)
      if (!ready) {
        ready = true;
        resize();
        for (let i = 0; i < COUNT; i += 1) parts.push(spawn({}, true));
      }
      running = true;
      last = performance.now();
      raf = requestAnimationFrame(tick);
    },
    stop() {
      running = false;
      cancelAnimationFrame(raf);
    },
  };
}
